// extracted by mini-css-extract-plugin
export default {"avatar":"AntAvatar_avatar__sHjaB"};